__turbopack_context__.v({
  "logo": "_2Pfo7a_logo",
});
